import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Button } from 'shared/components';

import theme from '../buttons.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  handleCreateClick: PropTypes.func.isRequired,
};

const CreateButton = ({ intl, handleCreateClick }) => (
  <Button
    label={ intl.formatMessage({ id: 'UserManagement.Label.ResetPasswordConfirm.Btn', defaultMessage: '** Reset' }) }
    className={ theme.createButton }
    iconName="check"
    onClick={ handleCreateClick }
  />
);

CreateButton.propTypes = propTypes;

export default injectIntl(CreateButton);
